// extracted by mini-css-extract-plugin
export default {"container":"alertBox_container__RnYcI","closeAlert":"alertBox_closeAlert__6rz-n","popLink":"alertBox_popLink__Greqv","popupBox":"alertBox_popupBox__H7RmX"};